import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import Paragraph from '../Paragraph/Paragraph';
import { HorizontalLine } from '../HorizontalLine/HorizontalLine';
import ChevronRight from '../Icons/ChevronRight';
import themeColors from '../../assets/styles/themeColors';

const SelectItemContainer = styled.button`
  cursor: pointer;
  outline: none;
  border: none;
  background-color: ${themeColors.colorBackgroundPrimary};
  ${({ selected }) =>
    selected &&
    `background-color: ${themeColors.colorBackgroundSecondaryLight}`};
  ${({ isChooseApp }) =>
    isChooseApp && `background-color: ${themeColors.colorBackgroundPrimary}`};
  width: 100%;
  padding: 0.75rem 1.625rem;
  margin-bottom: ${({ isChooseApp }) => (isChooseApp ? '10px' : '0px')};
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 1.5rem;
  align-items: center;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  &:hover {
    background-color: ${({ isChooseApp }) =>
      isChooseApp
        ? themeColors.colorBackgroundSecondaryLight
        : themeColors.colorBackgroundSecondary};
  }

  @media only screen and (max-width: 992px) {
    padding: 0.75rem;
  }
`;

const SelectItemContent = styled.div`
  margin-bottom: '10px';
  display: grid;
  grid-template-columns: 1;
  grid-gap: 0.5rem;
  text-align: left;
`;

const SelectItem = ({
  title,
  subtitle,
  description,
  onClick,
  showDivider = true,
  list,
  disabled,
  selected,
  isChooseApp,
  dataCy,
}) => (
  <>
    <SelectItemContainer
      type="button"
      disabled={disabled}
      selected={selected}
      onClick={onClick}
      isChooseApp={isChooseApp}
      data-cy={dataCy}
    >
      <SelectItemContent>
        <Paragraph fontWeight={600} color={themeColors.colorTextSecondary}>
          {title}
        </Paragraph>
        {subtitle && (
          <Paragraph variant="normal" color={themeColors.colorTextGrey}>
            {subtitle}
          </Paragraph>
        )}
        {description && (
          <Paragraph variant="normal" color={themeColors.colorTextGrey5}>
            {description}
          </Paragraph>
        )}
        {list &&
          list.map(({ text, fontWeight }) => (
            <Paragraph key={uuid()} fontWeight={fontWeight} variant="normal">
              &#8226; {text}
            </Paragraph>
          ))}
      </SelectItemContent>
      <ChevronRight />
    </SelectItemContainer>
    {showDivider && <HorizontalLine />}
  </>
);

SelectItem.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
  showDivider: PropTypes.bool,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      weight: PropTypes.number,
    }),
  ),
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  isChooseApp: PropTypes.bool,
  dataCy: PropTypes.string,
};

export default SelectItem;
